import {
    Box,
    BoxProps,
    Button as ChakraButton,
    ButtonProps as ChakraButtonProps,
    forwardRef
} from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

type ButtonProps = {
    innerContainerProps?: BoxProps;
} & ChakraButtonProps;

export const Button = forwardRef((props: PropsWithChildren<ButtonProps>, ref) => {
    const { children, loadingText, innerContainerProps, ...buttonProps } = props;

    return (
        <ChakraButton
            ref={ref}
            loadingText={loadingText ? <Box as="span">{loadingText}</Box> : null}
            {...buttonProps}
        >
            <Box as="span" {...innerContainerProps}>
                {children}
            </Box>
        </ChakraButton>
    );
});
